import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import axios from 'axios';

export function cn(...inputs: ClassValue[]) { return twMerge(clsx(inputs)); }

export function sharePointLinks(row: Record<string, unknown>): { name: string; url: string }[] {
  const listed = Array.isArray(row.sharePointFiles) ? row.sharePointFiles : [];
  const files = listed.flatMap((item) => {
    if (!item || typeof item !== 'object') return [];
    const file = item as { name?: unknown; url?: unknown };
    const url = String(file.url || '');
    if (!/^https?:\/\//i.test(url)) return [];
    return [{ name: String(file.name || 'Open file'), url }];
  });
  if (files.length) return files;
  const url = String(row.sharePointUrl || '');
  if (!/^https?:\/\//i.test(url)) return [];
  return [{ name: String(row.sourceFileName || 'Open file'), url }];
}

export function apiError(err: unknown, fallback: string): string {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as { error?: string; message?: string } | undefined;
    const error = data?.error?.trim();
    const message = data?.message?.trim();
    if (error && error !== "Internal Server Error") return error;
    if (message && message !== "Internal Server Error") return message;
    if (err.response?.status) return `${fallback} (${err.response.status})`;
  }
  if (err instanceof Error) {
    const message = err.message.trim();
    if (message && message !== 'Internal Server Error' && message !== 'failed') return message;
  }
  return fallback;
}
